import * as React from 'react';

import { iron, scienceBlue, black } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
  selected?: boolean;
  disabled?: boolean;
}

const Arrows: React.SFC<IconProps> = ({ selected, disabled, fill }) => {
  let color: string;
  if (fill) {
    color = fill;
  } else {
    color = disabled ? iron : selected ? scienceBlue : black;
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L24 0 24 24 0 24z" />
        <path
          fill={color}
          fillRule="nonzero"
          d="M8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35c-.19-.19-.51-.19-.7 0zM16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16z"
        />
      </g>
    </svg>
  );
};

export default Arrows;
